import {createContext} from 'react';

/** Layout id of the chart grid. The ids of its cards start with it. */
export const ChartGridContext = createContext<string | null>(null);
